import { h, Component } from 'preact';
import SimpleField from 'components/editor/settings/simpleField';
import DateField from 'components/editor/settings/dateField';
import { joinClasses } from 'utils/utils';
import * as jsonPointer from 'utils/jsonPointer';
import Store from 'store/store';
import Button from 'components/button/button';
import s from 'components/pageSettings/schemaObject.sss';
import { camelCaseToTitleCase, orders, masks, textAreas, dates, getName } from 'utils/schema';

export default class SchemaObject extends Component {
	constructor(props) {
		super(props);
		this.state = {
			collapsed: false
		};
		this.toggleCollapse = this.toggleCollapse.bind(this);
	}

	toggleCollapse(e) {
		e.preventDefault();
		this.setState({ collapsed: !this.state.collapsed });
	}

	buildBlankObject(data) {
		if (typeof data === 'string') {
			return '';
		} else if (typeof data === 'object') {
			const newObj = {};
			Object.keys(data).forEach(key => {
				newObj[key] = this.buildBlankObject(data[key]);
			});
			return newObj;
		} else {
			return null;
		}
	}

	addSubEntry(e, data) {
		e.preventDefault();
		const newEntry = this.buildBlankObject(data[0]);
		const newData = [...data, newEntry];
		jsonPointer.set(Store.get().data, this.props.path, newData);
		this.forceUpdate();
		
	}

	sortKeysByOrder(objKey, keys) {
		let order = [];
		const sortedKeys = [];
		if (orders[objKey]) {
			order = orders[objKey];
		} else {
			order = orders.default;
		}
		order.forEach(key => {
			if (keys.includes(key)) {
				sortedKeys.push(key);
			}
		});
		keys.forEach(key => {
			if (!order.includes(key)) {
				sortedKeys.push(key);
			}
		});
		return sortedKeys;
	}

	render(props) {
		const { data, path } = props;
		const objKey = path.split('/')[path.split('/').length - 1];
		const parent = path.split('/')[path.split('/').length - 2];
		let title = objKey;
		if (typeof parseInt(objKey) === 'number' && !isNaN(parseInt(objKey))) {
			title = parent;
		}
		if (title in masks) {
			title = masks[title];
		} else {
			if (parent === 'schema') {
				title = camelCaseToTitleCase(title) + 's';
			} else {
				title = camelCaseToTitleCase(title);
			}
		}
		const keys = this.sortKeysByOrder(objKey, Object.keys(data));
		return (
			<div class={s.wrapper}>
				{objKey !== 'schema' && (
					<div class={s.titleBarWrapper}>
						<button class={joinClasses(s.titleBar, this.state.collapsed && s.collapsed)} onClick={(e) => this.toggleCollapse(e)}>
							{title}
						</button>
						{(data.length || data.length === 0) && (
							<Button class={s.subEntryButton} icon="plus" onClick={(e) => this.addSubEntry(e, data)}>
								Add sub entry
							</Button>
						)}
					</div>
				)}
				{!this.state.collapsed && keys.map(key => {
					const field = data[key];
					let fieldTitle = getName(key);
					if (!props.path.endsWith('schema') && !fieldTitle.startsWith('@')) {
						const previousPathSegment = objKey.match(/^\d+$/) ? parent : objKey;
						fieldTitle = `${getName(previousPathSegment)} ${fieldTitle}`;
					}
					if (typeof field === 'string') {
						if (dates.includes(key)) {
							return (
								<DateField 
									label={fieldTitle}
									note={key}
									path={`${path}/${key}`}
								/>
							);
						}
						return (
							<SimpleField 
								label={fieldTitle}
								note={key}
								path={`${path}/${key}`}
								multiline={textAreas.includes(key)}
							/>
						);
					} else if (typeof field === 'object') {
						return (
							<SchemaObject
								data={field}
								path={`${path}/${key}`}
							/>
						);
					}
				})}
			</div>
		);
	}
}